import { Collapse, Modal, Table, type TableProps } from "antd";
import styled from "styled-components";
import { color } from "../../resource";

export const Wrapper = styled.div`
  .ant-collapse {
    border-radius: 1px !important;
    border: 0px solid !important;
    background-color: rgb(255, 255, 255) !important;
  }
`;
export const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    height: 90px !important;
    background-color: #f3f6f9;
    border-radius: 0px !important;
    display: flex !important;
    align-items: center !important;
  }
  .ant-collapse-content-box {
    padding: 22px !important;
    background-color: #babcbe !important;
  }
`;
export const StyledTable = styled(Table)<TableProps<any> & { rowBackgroundColor?: string }>`
  .ant-table-content {
    margin-right: 16px !important;
  }
  .ant-table-expanded-row {
    > td {
      padding-top: 0px !important;
      padding-bottom: 20px !important;
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
  .ant-table-expanded-row td .ant-table {
    thead tr th:first-child,
    tbody tr td:first-child {
      display: none !important;
    }
  }

  .ant-table-container table thead tr th {
    font-family: "IBM Plex Sans Thai", sans-serif !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    color: #6b7995 !important;
    background: #fff !important;
  }

  .ant-table-footer {
    display: flex;
    justify-content: flex-end;
    background: #f3f6f9 !important;
    width: auto;
    box-sizing: border-box;
    padding-right: 24px !important;
    margin-left: 50px !important;
    margin-right: 16px !important;
  }
  && tbody > tr > td {
    background: #f3f6f9 !important;
    border: 0px;
    padding: 10px;
    align-content: center;
  }

  && tbody > tr > td:nth-child(1),
  && tbody > tr:hover > td:nth-child(1) {
    background: transparent !important;
  }
`;

export const CardIndex = styled.div`
  background: #6b7995 !important;
  height: 56px;
  width: 56px;
  border-radius: 4px;
  color: #fff;
  font-size: 24px;
  font-weight: 600 !important;
  font-family: "Helvetica" !important;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CustomModal = styled(Modal)`
  .ant-modal-content {
    padding: 20px 0 !important;
  }
`;
export const ZoneWrapper = styled.div<{ show: boolean }>`
  overflow: hidden;
  transition: all 0.3s ease;
  max-height: ${({ show }) => (show ? "200px" : "0")};
  opacity: ${({ show }) => (show ? 1 : 0)};
`;
export const footerStyle = {
  backgroundColor: "#fff",
  padding: "12px",
  display: "flex",
  justifyContent: "end",
};

export const addBoxStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px dashed #0068F4",
  padding: 10,
  borderRadius: 6,
  width: "93%",
  cursor: "pointer",
};
export const iconStyle = {
  width: 32,
  height: 32,
  cursor: "pointer",
  backgroundColor: color.white,
  padding: 4,
  borderRadius: 4,
  border: `0.3px solid ${color.background2}`,
};
